var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyTarifasFondo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 148.074,
    height: 121.545,
    viewBox: "0 0 148.074 121.545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fondo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M133.63 33.5014C137.924 38.5768 147.944 51.8512 148.074 70.3311C148.074 76.8382 148.204 87.77 140.266 97.0099C132.198 106.25 118.535 110.935 107.865 107.681C101.228 105.729 102.269 102.606 93.6811 99.3525C92.2497 98.8319 75.7237 92.7153 64.9232 100.654C61.1496 103.387 61.9303 105.079 58.1567 109.243C57.3759 110.154 44.7537 123.819 27.3168 121.216C13.7836 119.264 2.46266 108.072 0.380645 96.6195C-0.530239 91.544 0.380645 86.859 1.1614 82.9548C2.98317 73.8449 5.84594 72.4134 8.18822 63.5638C8.96897 60.8309 10.9209 53.0224 9.48948 43.6523C7.79784 32.7205 3.24342 31.9397 3.24342 24.0011C3.1133 16.1927 7.40746 5.78143 16.9067 1.74707C24.5841 -1.50644 33.9532 -0.0748963 39.4185 4.87044C41.8909 7.21297 41.8909 8.64452 43.8428 11.6378C50.3491 21.2682 62.8412 23.7408 71.2994 25.5628C76.5045 26.6039 88.8664 29.0766 101.619 24.5217C103.961 23.7408 104.091 23.3504 105.783 22.96C115.803 20.6174 126.213 27.2546 133.63 33.5014V33.5014Z",
    fill: "#C7B8FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTarifasFondo);
export default __webpack_public_path__ + "static/media/empty-tarifas-fondo.e1da4b7c706efcf92dc3c1b1cc82836b.svg";
export { ForwardRef as ReactComponent };